import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from './ui/Button';
interface PricingSectionProps {
  packageName?: string;
  duration?: string;
  price?: string;
  description?: string;
}
export function PricingSection({
  packageName = 'Standard Package',
  duration = '14 Days • All Inclusive',
  price = '$1,588',
  description = 'Best value package including all essential services, permits, and accommodation. No hidden costs.'
}: PricingSectionProps) {
  const included = ['Airport pickups and drops by private vehicle', '3-star hotel in Kathmandu (2 nights)', 'Teahouse accommodation during trek', 'All meals (Breakfast, Lunch, Dinner)', 'Domestic flights (Kathmandu - Lukla)', 'Experienced English-speaking guide', 'Porters (1 porter for 2 trekkers)', 'Sagarmatha National Park permits', "Trekkers' Information Management System (TIMS) card", 'First aid kit and Oximeter', 'Duffle bag, sleeping bag, and down jacket'];
  const notIncluded = ['International airfare', 'Nepal entry visa fee', 'Travel insurance (Mandatory)', 'Personal expenses (Wifi, charging, showers)', 'Tips for guide and porters', 'Alcoholic and soft drinks', 'Extra nights accommodation if needed', 'Emergency evacuation costs'];
  return <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-260">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-0" data-id="element-261">
        {/* Price Card - Left Side */}
        <div className="bg-gradient-to-br from-[#0066FF] to-[#0052CC] p-8 lg:p-10 text-white flex flex-col justify-between" data-id="element-262">
          <div data-id="element-263">
            <h3 className="text-2xl font-bold mb-2" data-id="element-264">{packageName}</h3>
            <p className="text-blue-100 mb-8" data-id="element-265">{duration}</p>

            <div className="mb-8" data-id="element-266">
              <div className="flex items-baseline gap-2" data-id="element-267">
                <span className="text-6xl font-bold" data-id="element-268">{price}</span>
                <span className="text-xl text-blue-100" data-id="element-269">/ person</span>
              </div>
            </div>

            <p className="text-blue-50 text-sm leading-relaxed mb-8" data-id="element-270">
              {description}
            </p>
          </div>

          <div data-id="element-271">
            <Button variant="primary" className="w-full bg-white text-[#0066FF] hover:bg-blue-50 font-bold text-lg py-4" data-id="element-272">
              BOOK NOW
            </Button>
            <p className="text-blue-100 text-xs text-center mt-3" data-id="element-273">
              *Group discounts available for 4+ people
            </p>
          </div>
        </div>

        {/* What's Included - Middle */}
        <div className="p-8 lg:p-10 bg-white" data-id="element-274">
          <div className="flex items-center gap-3 mb-6" data-id="element-275">
            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-276">
              <Check size={18} className="text-green-600" data-id="element-277" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-278">
              What's Included
            </h3>
          </div>

          <ul className="space-y-4" data-id="element-279">
            {included.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-280">
                <Check size={20} className="text-green-600 flex-shrink-0 mt-0.5" data-id="element-281" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-282">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* What's Not Included - Right */}
        <div className="p-8 lg:p-10 bg-gray-50" data-id="element-283">
          <div className="flex items-center gap-3 mb-6" data-id="element-284">
            <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-285">
              <X size={18} className="text-red-600" data-id="element-286" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-287">
              What's Not Included
            </h3>
          </div>

          <ul className="space-y-4" data-id="element-288">
            {notIncluded.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-289">
                <X size={20} className="text-red-600 flex-shrink-0 mt-0.5" data-id="element-290" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-291">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}